import { useStaticQuery, graphql } from "gatsby"

const useGlobalComponents = () => {
  const { allWpGlobalComponent } = useStaticQuery(graphql`
    query GlobalComponents {
      allWpGlobalComponent {
        nodes {
          databaseId
          slug
          nodeType
          acf {
            contentBlocks {
              __typename
              ... on WpGlobalComponent_Acf_ContentBlocks_Breadcrumbs {
                fieldGroupName
                alignment
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_InteractiveBanner {
                subtitle
                title
                fieldGroupName
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_PageBanner {
                fieldGroupName
                parallax
                height
                slides {
                  content
                  video
                  title
                  button {
                    title
                    url
                  }
                  image {
                    altText
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 2000)
                      }
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_MachineBanner {
                fieldGroupName
                style
                title
                category
                description
                style
                button {
                  url
                  title
                }
                brand {
                  ... on WpBrand {
                    ...BrandCard
                  }
                }
                backgroundImage {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 2000)
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_Testimonials {
                fieldGroupName
                title
                testimonialSlider {
                  ctaBoxDescription
                  ctaBoxDescriptionSecond
                  ctaBoxTitle
                  ctaBoxTitleSecond
                  fieldGroupName
                  jobTitle
                  name
                  testimonial
                  secondTextField
                  portraitImage {
                    altText
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 1000)
                      }
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_Timeline {
                fieldGroupName
                title
                events {
                  year
                  content
                  image {
                    altText
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 1000)
                      }
                    }
                  }
                }
                backgroundImage {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 2000)
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_TeamArchive {
                fieldGroupName
                title
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_ExpertsShowcase {
                fieldGroupName
                title
                items: experts {
                  ... on WpTeam {
                    ...TeamCard
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_BrandsShowcase {
                fieldGroupName
                disableLinking
                brands {
                  ... on WpBrand {
                    ...BrandCard
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_CategoryArchive {
                fieldGroupName
                content
                title
                categories {
                  ... on WpMachine {
                    ...MachineCard
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_BrandsArchive {
                fieldGroupName
                content
                title
                brands {
                  ... on WpBrand {
                    ...BrandCard
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_MachineArchive {
                fieldGroupName
                title
                content
                machines {
                  ... on WpMachine {
                    ...MachineCard
                  }
                }
                machineItems {
                  machine {
                    ... on WpMachine {
                      ...MachineCard
                    }
                  }
                  subMachines {
                    title
                    content
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_PostsArchive {
                fieldGroupName
                title
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_RelatedTopics {
                fieldGroupName
                title
                items: posts {
                  ... on WpResource {
                    ...ResourceCard
                  }
                  ... on WpPost {
                    ...ArticleCard
                  }
                  ... on WpMachine {
                    ...MachineCard
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_LatestArticles {
                fieldGroupName
                style
                title
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_IconBanner {
                fieldGroupName
                subtitle
                title
                backgroundImage {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 2000)
                    }
                  }
                }
                icon {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 1000)
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_BrandIntro {
                fieldGroupName
                logo {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 600)
                    }
                  }
                }
                title
                content
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_CategoryBanner {
                content
                fieldGroupName
                title
                button {
                  target
                  title
                  url
                }
                backgroundImage {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 2000)
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_Gallery {
                fieldGroupName
                gallery {
                  altText
                  caption
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 1200)
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_VideoBlock {
                fieldGroupName
                title
                video
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_ResourcesBlock {
                fieldGroupName
                resources {
                  ... on WpResource {
                    ...ResourceCard
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_TabbedContent {
                fieldGroupName
                title
                style
                tabs {
                  ... on WpGlobalComponent_Acf_ContentBlocks_TabbedContent_Tabs_CarouselContent {
                    alignment
                    content
                    tabTitle
                    fieldGroupName
                    carousel {
                      altText
                      localFile {
                        childImageSharp {
                          gatsbyImageData(width: 1000, height: 750)
                        }
                      }
                    }
                  }
                  ... on WpGlobalComponent_Acf_ContentBlocks_TabbedContent_Tabs_AccordianContent {
                    alignment
                    content
                    tabTitle
                    fieldGroupName
                    accordian {
                      content
                      title
                    }
                  }
                  ... on WpGlobalComponent_Acf_ContentBlocks_TabbedContent_Tabs_Video {
                    fieldGroupName
                    tabTitle
                    video
                  }
                  ... on WpGlobalComponent_Acf_ContentBlocks_TabbedContent_Tabs_IconsGrid {
                    fieldGroupName
                    tabTitle
                    items {
                      title
                      subtitle
                      icon {
                        altText
                        localFile {
                          childImageSharp {
                            gatsbyImageData(width: 1000)
                          }
                        }
                      }
                    }
                  }
                  ... on WpGlobalComponent_Acf_ContentBlocks_TabbedContent_Tabs_ColumnContent {
                    fieldGroupName
                    tabTitle
                    items {
                      content
                    }
                  }
                  ... on WpGlobalComponent_Acf_ContentBlocks_TabbedContent_Tabs_ApplicationGallery {
                    fieldGroupName
                    tabTitle
                    items {
                      fieldGroupName
                      imageTitle
                      blurb
                      image {
                        altText
                        localFile {
                          childImageSharp {
                            gatsbyImageData(width: 1000)
                          }
                        }
                      }
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_ActiveCampaignForm {
                fieldGroupName
                content
                formId
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_TabbedComponents {
                fieldGroupName
                title
                tabs {
                  fieldGroupName
                  tabTitle
                  video
                  leftColumn {
                    fieldGroupName
                    buttonText
                    buttonUrl
                    content
                    title
                  }
                  rightColumn {
                    fieldGroupName
                    content
                    title
                    accordian {
                      content
                      title
                    }
                    gallery {
                      caption
                      localFile {
                        childImageSharp {
                          gatsbyImageData(width: 1000)
                        }
                      }
                    }
                  }
                  iconList {
                    fieldGroupName
                    title
                    subtitle
                    icon {
                      id
                      localFile {
                        childImageSharp {
                          gatsbyImageData(width: 1000)
                        }
                      }
                    }
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_InStockMachine {
                fieldGroupName
                title
                blurb
                bulletPoints {
                  fieldGroupName
                  bulletPointText
                }
                machineGallery {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 2000, height: 1400)
                    }
                  }
                }
                label
                location
                shippingText
                brochure {
                  ... on WpResource {
                    ...ResourceCard
                  }
                }
                darkMode
                youtubeLink
                videoFile {
                  link
                  localFile {
                    size
                    extension
                    publicURL
                  }
                }
              }
              ... on WpGlobalComponent_Acf_ContentBlocks_ApplicationGallery {
                fieldGroupName
                title
                darkMode
                items {
                  fieldGroupName
                  imageTitle
                  blurb
                  image {
                    altText
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 1000)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return allWpGlobalComponent.nodes
}

export default useGlobalComponents